export const getMobileColSpan = (columns: number | undefined) => {
  // https://tailwindcss.com/docs/content-configuration#dynamic-class-names
  switch (columns) {
    case 0:
      return "xs:hidden";
    case 1:
      return "xs:col-span-1 xs:block";
    case 2:
      return "xs:col-span-2 xs:block";
    case 3:
      return "xs:col-span-3 xs:block";
    case 4:
      return "xs:col-span-4 xs:block";
    case 5:
      return "xs:col-span-5 xs:block";
    case 6:
      return "xs:col-span-6 xs:block";
    case 7:
      return "xs:col-span-7 xs:block";
    case 8:
      return "xs:col-span-8 xs:block";
    case 9:
      return "xs:col-span-9 xs:block";
    case 10:
      return "xs:col-span-10 xs:block";
    case 11:
      return "xs:col-span-11 xs:block";
    case 12:
      return "xs:col-span-12 xs:block";
  }
  return "xs:col-span-12 xs:block";
};

export const getTabletColSpan = (columns: number | undefined) => {
  // https://tailwindcss.com/docs/content-configuration#dynamic-class-names
  switch (columns) {
    case 0:
      return "tablet:hidden";
    case 1:
      return "tablet:col-span-1 tablet:block";
    case 2:
      return "tablet:col-span-2 tablet:block";
    case 3:
      return "tablet:col-span-3 tablet:block";
    case 4:
      return "tablet:col-span-4 tablet:block";
    case 5:
      return "tablet:col-span-5 tablet:block";
    case 6:
      return "tablet:col-span-6 tablet:block";
    case 7:
      return "tablet:col-span-7 tablet:block";
    case 8:
      return "tablet:col-span-8 tablet:block";
    case 9:
      return "tablet:col-span-9 tablet:block";
    case 10:
      return "tablet:col-span-10 tablet:block";
    case 11:
      return "tablet:col-span-11 tablet:block";
    case 12:
      return "tablet:col-span-12 tablet:block";
  }
  return "tablet:col-span-12 tablet:block";
};

export const getDesktopColSpan = (columns: number | undefined) => {
  // https://tailwindcss.com/docs/content-configuration#dynamic-class-names
  switch (columns) {
    case 0:
      return "desktop:hidden";
    case 1:
      return "desktop:col-span-1 desktop:block";
    case 2:
      return "desktop:col-span-2 desktop:block";
    case 3:
      return "desktop:col-span-3 desktop:block";
    case 4:
      return "desktop:col-span-4 desktop:block";
    case 5:
      return "desktop:col-span-5 desktop:block";
    case 6:
      return "desktop:col-span-6 desktop:block";
    case 7:
      return "desktop:col-span-7 desktop:block";
    case 8:
      return "desktop:col-span-8 desktop:block";
    case 9:
      return "desktop:col-span-9 desktop:block";
    case 10:
      return "desktop:col-span-10 desktop:block";
    case 11:
      return "desktop:col-span-11 desktop:block";
    case 12:
      return "desktop:col-span-12 desktop:block";
  }
  return "desktop:col-span-12 desktop:block";
};

export const getColSpan = (columns: number) => {
  // https://tailwindcss.com/docs/content-configuration#dynamic-class-names
  switch (columns) {
    case 1:
      return "col-span-1";
    case 2:
      return "col-span-2";
    case 3:
      return "col-span-3";
    case 4:
      return "col-span-4";
    case 5:
      return "col-span-5";
    case 6:
      return "col-span-6";
    case 7:
      return "col-span-7";
    case 8:
      return "col-span-8";
    case 9:
      return "col-span-9";
    case 10:
      return "col-span-10";
    case 11:
      return "col-span-11";
    case 12:
      return "col-span-12";
  }
  return "col-span-12";
};
